import script from "./PriceAlertsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceAlertsTable.vue?vue&type=script&setup=true&lang=js"

import "./PriceAlertsTable.vue?vue&type=style&index=0&id=7928a06e&lang=scss"

const __exports__ = script;

export default __exports__